var defaultConf = require('./config-default');
var BO_URL = 'jasfgg2023-data.ms-dev.mobile-spot.com'; // 'mom202301-data-dev.mobile-spot.com' // to test google maps;
var NODE_BACKEND_DOMAIN = 'jasfgg-node-backend-dev.mobile-spot.com';
var NODE_WS_BAKEND_DOMAIN = '';
var LOCAL_NODE_BACKEND_DOMAIN = 'http://localhost:3082';
module.exports = require('deepmerge')(defaultConf, {
  ENV: 'dev',
  BO_URL: BO_URL,
  // no trailing '/'

  BO_PATH: '/home/legacy/b4event/jasfgg2023/jasfgg2023-data.ms-dev.mobile-spot.com',
  // no trailing '/'
  BO_SERVER_ALIAS: 'ms-dev.mobilespot.prodleni.local',
  BO_SSH_USER: 'legacy',
  // 'www'
  BO_SSH_PORT: '43122',
  //'43122'

  DEPLOY_PATH: '/home/legacy/b4event/jasfgg2023/jasfgg2023.ms-dev.mobile-spot.com',
  //GOOGLE_ANALYTICS_ID: 'UA-48506479-39',
  GOOGLE_ANALYTICS_ID_V4: '',
  projectId: '1056757301402',
  // FCM sender id
  appId: 'EF7A9-340CB',
  // pushwoosh appid

  SEND_EXPORTED_NOTES_MAIL: {
    WS_URL: 'http://localhost:3096/api/exportNotesByMail',
    EXPEDITOR: 'no-reply@mobile-spot.com',
    KEY: 'zpgZkgiz845gjzFzi'
  },
  ADDITIONAL_DEFAULTSRC_CSP: (Array.isArray(defaultConf.ADDITIONAL_DEFAULTSRC_CSP) ? defaultConf.ADDITIONAL_DEFAULTSRC_CSP : []).concat([]),
  CHECK_NETWORK_URL: "https://".concat(BO_URL, "/online.txt"),
  REAL_TIME: {
    URL: "https://".concat(NODE_WS_BAKEND_DOMAIN)
  }
});